import axios, { Method } from "axios";

type AxiosCallParams = {
  method: Method;
  host: string;
  endpoint?: string;
  data?: any;
  params?: any;
  headers?: Record<string, string>;
  timeout?: number;
  withCredentials?: boolean;
};

export async function createAxiosCall<T = any>({
  method,
  host,
  endpoint = "",
  data,
  params,
  headers = {},
  timeout = 15000,
  withCredentials = false,
}: AxiosCallParams): Promise<T> {
  const url = endpoint ? `${host}/${endpoint}` : host;

  const response = await axios({
    method,
    url,
    data,
    params,
    timeout,
    withCredentials,
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  });

  return response.data;
}
